import React, { memo, useRef, useState } from 'react';

import { ChevronArrowLeftIcon } from '../../assets/icons/ChevronArrowLeftIcon';
import { ChevronArrowRightIcon } from '../../assets/icons/ChevronArrowRightIcon';
import useCarouselBehaviour from '../../hooks/useCarouselBehaviour/useCarouselBehaviour';
import useControlledTimer from '../../hooks/useControlledTimer/useControlledTimer';
import { getMergedClassNames, getUniqueKey } from '../../utils/HTMLutils';
import './CarouselTouchFrendly.scss';

const rootClassName = 'component-carousel-touch-frendly';
interface CarouselTouchFrendlyProps {
  className?: string;
  slides?: React.ReactNode[];
  timeout?: number;
}

function CarouselTouchFrendly(props: CarouselTouchFrendlyProps) {
  const [id] = useState<any>(getUniqueKey());
  const [atual, setAtual] = useState<number>(0);
  const atualRef = useRef<number>(atual);
  atualRef.current = atual;

  const [CarouselBehaviour, handleChange] = useCarouselBehaviour({
    atual,
    setAtual,
    slides:
      props.slides?.map((slide, index) => {
        return (
          <div key={index} className={`${rootClassName}-slide`}>
            {slide}
          </div>
        );
      }) ?? [],
  });

  const [dispatchActionsToTimer] = useControlledTimer({
    timeout: props.timeout ? props.timeout : 0,
    callbackTrigger: () => {
      handleChange(
        atualRef.current < (props.slides?.length ?? 1) - 1
          ? atualRef.current + 1
          : 0,
        false
      );
    },
  });

  return (
    <div
      id={id}
      className={getMergedClassNames([rootClassName, props.className])}
    >
      <div
        className={`${rootClassName}-outside-content`}
        onMouseEnter={() => {
          dispatchActionsToTimer('pause');
        }}
        onMouseLeave={() => {
          dispatchActionsToTimer('play');
        }}
      >
        {(props.slides?.length ?? 0) > 1 && (
          <div
            className={`${rootClassName}-control prev`}
            onClick={() => {
              dispatchActionsToTimer('stop');
              handleChange(
                atual > 0 ? atual - 1 : (props.slides?.length ?? 0) - 1,
                false
              );
            }}
          >
            <div className={`${rootClassName}-icon`}>
              <ChevronArrowLeftIcon />
            </div>
            <div className={`${rootClassName}-shadow`} />
          </div>
        )}
        {(props.slides?.length ?? 0) > 1 && (
          <div
            className={`${rootClassName}-control next`}
            onClick={() => {
              dispatchActionsToTimer('stop');
              handleChange(
                atual < (props.slides?.length ?? 1) - 1 ? atual + 1 : 0,
                false
              );
            }}
          >
            <div className={`${rootClassName}-icon`}>
              <ChevronArrowRightIcon />
            </div>
            <div className={`${rootClassName}-shadow`} />
          </div>
        )}
        {CarouselBehaviour}
      </div>
      <div className={`${rootClassName}-balls`}>
        {props.slides?.map((_slide, index) => {
          return (
            <div
              key={index}
              onClick={() => {
                dispatchActionsToTimer('restart');
                handleChange(index, false);
              }}
              className={getMergedClassNames([
                `${rootClassName}-ball`,
                index === atual ? 'atual' : '',
              ])}
            />
          );
        })}
      </div>
    </div>
  );
}

export default memo(CarouselTouchFrendly);
